import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelDynamic as _vModelDynamic, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@img/icon-close2.png'


const _withScopeId = n => (_pushScopeId("data-v-22efddd4"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "sign-in" }
const _hoisted_4 = {
  key: 0,
  class: "inner-login"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "protocol" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "top" }
const _hoisted_12 = ["src"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Return", -1))
const _hoisted_14 = { class: "title" }
const _hoisted_15 = ["placeholder"]
const _hoisted_16 = { class: "input-container" }
const _hoisted_17 = ["placeholder"]
const _hoisted_18 = { class: "tips" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_20 = { class: "top" }
const _hoisted_21 = ["src"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Return", -1))
const _hoisted_23 = { class: "title" }
const _hoisted_24 = ["placeholder"]
const _hoisted_25 = { class: "input-container" }
const _hoisted_26 = ["type", "placeholder"]
const _hoisted_27 = ["src"]

import CusModal from "@/components/CusModal/index.vue";
import { Popover } from "ant-design-vue";
import { apiGetMailCode } from "@api/login";
import { useloginStore } from "@/store/login";
import { Modal, message } from "ant-design-vue";
import { storeToRefs } from "pinia";
import { firebase, fbInit, fbLogin } from "@/js/firebasesdk/index";
import { ref, onMounted, computed, watch } from "vue";
import { isDev } from "@/config";
import { useI18n } from "vue-i18n";
import { uselangStore } from "@/store/lang";
import { trackCustomizeEvent } from "@/js/stastic";

// trackCustomizeEvent({
//     event_id: "webrtc_performance",
//     params: {
//       game_monitor: data,
//       game_node: currentGameNode,
//       game_info: currentGame?.gameId,
//     },
//   });

import pb from "@/pb/index.json";
type IProtocolUrlMap = {
  terms: string;
  privacy: string;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const MailCodeType = pb.nested.yunpb.nested.MailCodeType.values;
const MailResStatus = pb.nested.yunpb.nested.MailResStatus.values;

const protocolUrlMap: IProtocolUrlMap = {
  terms: "http://www.chikiigame.com/m/userAgreements/index.html",
  privacy: "http://www.chikiigame.com/m/privacy/index.html",
};

const facebookConfig = {
  flag: "facebook",
  token: "",
  loginType: 10,
  id: "577841626490956",
  version: "v10.0",
};

const googleConfig = {
  flag: "google",
  token: "",
  loginType: 9,
};

const emailConfig = {
  flag: "email",
  token: "",
  loginType: 12,
};

const chikiiIdConfig = {
  flag: "ID",
  token: "",
  loginType: 0,
};

const loginStore = useloginStore();
const langStore = uselangStore();
const { t } = useI18n();
const { isShow } = storeToRefs(loginStore);
const isShowPassward = ref(false); // 是否显示密码
const isAgree = ref(false); // 是否勾选协议
const isAgreeProtoModal = ref(false); // 登录的未勾选协议的提示弹窗
const tokenByInit = ref("");
const countTime = ref(0);
const timer = ref();
const IdAcount = ref("");
const IdPassword = ref("");
const emailAcount = ref("");
const emailVerifyCode = ref();
const innerLogin = ref<any>(null);
const activeFlag = ref("");
const checkCanLogin = computed(() => {
  let res;
  if (activeFlag.value === emailConfig.flag) {
    res = checkEmail.value && emailVerifyCode.value;
  } else if (activeFlag.value === chikiiIdConfig.flag) {
    res = IdAcount.value && IdPassword.value;
  }
  return res;
});

const checkEmail = computed(() => {
  const rule = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/;
  return rule.test(emailAcount.value);
});

const handleClose = () => {
  isShow.value = false;
};

const clear = () => {
  clearInterval(timer.value);
  activeFlag.value = "";
  emailAcount.value = "";
  emailVerifyCode.value = "";
  IdAcount.value = "";
  IdPassword.value = "";
  isAgree.value = false;
};

const startCountDown = () => {
  clearInterval(timer.value);
  timer.value = setInterval(() => {
    if (countTime.value <= 0) {
      clearInterval(timer.value);
      countTime.value = 0;
      return;
    }
    countTime.value--;
  }, 1000);
};

const handleSendVerifyCode = async () => {
  if (!emailAcount.value) {
    message.error(t("LoginModal.enterEmailText"));
    return;
  }
  if (!checkEmail.value) {
    message.error(t("LoginModal.emailFormatErrText"));
    return;
  }
  if (countTime.value > 0) return;
  try {
    const res = await apiGetMailCode({
      lang: langStore.lang,
      mail: emailAcount.value,
      type: MailCodeType.MCT_TYPE_LOGIN,
    });
    if (res.resStatus === MailResStatus.MAIL_CODE_SEND_SUCC) {
      countTime.value = 60;
      startCountDown();
      message.success(t("LoginModal.sendVerifyCodeSuccess"));
    } else {
      message.error(t("LoginModal.sendVerifyCodeFaild"));
    }
  } catch (error) {
    const err = error as any;
    message.error({
      content:
        err.description?.desc ||
        err.message ||
        t("LoginModal.sendVerifyCodeFaild"),
    });
  }
};
const handleInnerLogin = () => {
  if (innerLogin.value) {
    loginStore.chikiiLogin({
      loginType: 11,
      phone: `${innerLogin.value}`,
      token: "",
      flag: "innerlogin",
    });
  }
};

// 跳转协议页
const gotoProtocolPage = (type: keyof IProtocolUrlMap) => {
  if (!protocolUrlMap[type]) return;
  window.open(protocolUrlMap[type], "_blank");
};
const handleConfirm = () => {
  isAgree.value = true;
  isAgreeProtoModal.value = false;
};

const hideLoginModal = () => {
  console.log("hideLoginModel");
  loginStore.setIsModalVisable(false);
};
//  登录的下一步操作
const handleNextLogin = (flag: string) => {
  trackCustomizeEvent({
    event_id: "chikiiweb-login-btn-click",
    flag: flag,
  });
  if (!isAgree.value) {
    isAgreeProtoModal.value = true;
    return;
  }
  activeFlag.value = flag;
};
// facebook login
const handleFacebookLogin = async () => {
  trackCustomizeEvent({
    event_id: "chikiiweb-login-btn-click",
    flag: "Facebook",
  });
  if (!isAgree.value) {
    isAgreeProtoModal.value = true;
    return;
  }
  try {
    if (tokenByInit.value) {
      console.log(tokenByInit.value, "token");
      loginStore.chikiiLogin({ ...facebookConfig, token: tokenByInit.value });
    } else {
      const { accessToken } = await fbLogin();
      loginStore.chikiiLogin({ ...facebookConfig, token: accessToken });
    }
    trackCustomizeEvent({
      event_id: "chikiiweb-login-result",
      flag: "Facebook",
      res: "success",
    });
  } catch (error) {
    console.log(error, "faceBookLoginErr");
  }
};
// google login
const handleGoogleLogin = async () => {
  trackCustomizeEvent({
    event_id: "chikiiweb-login-btn-click",
    flag: "Google",
  });
  if (!isAgree.value) {
    isAgreeProtoModal.value = true;
    return;
  }
  console.log("googleLogin");
  const provider = new firebase.auth.GoogleAuthProvider();
  try {
    await firebase.auth().signInWithPopup(provider);
    const token = await firebase.auth().currentUser?.getIdToken(true);
    loginStore.chikiiLogin({ ...googleConfig, token: token as string });
    trackCustomizeEvent({
      event_id: "chikiiweb-login-result",
      flag: "Google",
      res: "success",
    });
  } catch (error) {
    console.log(error, "googleLogin");
  }
};

// email login
const handleEmailLogin = async () => {
  if (!checkCanLogin.value) return;

  try {
    loginStore
      .chikiiLogin({
        ...emailConfig,
        passwordMd5: emailVerifyCode.value,
        phone: emailAcount.value,
      })
      .then(() => {
        trackCustomizeEvent({
          event_id: "chikiiweb-login-result",
          flag: activeFlag.value,
          res: "success",
        });
        clear();
      });
  } catch (error) {
    const err = error as any;
    message.error({
      content:
        err.description?.desc || err.message || t("LoginModal.loginFaild"),
    });
  }
};

const handleIdLogin = () => {
  if (!checkCanLogin.value) {
    message.info(t("LoginModal.idMsgInfo"));
    return;
  }
  loginStore
    .chikiiLogin({
      ...chikiiIdConfig,
      passwordMd5: IdPassword.value,
      phone: IdAcount.value,
    })
    .then(() => {
      trackCustomizeEvent({
        event_id: "chikiiweb-login-result",
        flag: activeFlag.value,
        res: "success",
      });
      clear();
    });
};

const handleAgree = () => {
  isAgree.value = !isAgree.value;
};
const faceBookFireBaseFbinit = () => {
  console.log("faceBookFireBaseFbinit");
  fbInit(facebookConfig.id, facebookConfig.version)
    .then((res: any) => {
      tokenByInit.value = res.accessToken;
      console.log(res, "fbInit");
    })
    .catch((err: any) => {
      console.log(err, "err");
    });
};
onMounted(() => {
  faceBookFireBaseFbinit();
});

return (_ctx: any,_cache: any) => {
  const _component_i18n_t = _resolveComponent("i18n-t")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Modal), {
      bodyStyle: {
      backgroundColor: '#292929',
      borderRadius: '12px',
      position: 'relative',
      padding: '0',
    },
      maskClosable: false,
      width: "460px",
      centered: true,
      visible: _unref(isShow),
      "onUpdate:visible": _cache[12] || (_cache[12] = ($event: any) => (_isRef(isShow) ? (isShow).value = $event : null)),
      footer: false,
      onCancel: clear
    }, {
      default: _withCtx(() => [
        _createElementVNode("img", {
          src: _imports_0,
          alt: "",
          class: "custom-close",
          onClick: handleClose
        }),
        _createElementVNode("img", {
          class: "login-header",
          src: require('@/assets/img/login-bg.png')
        }, null, 8, _hoisted_1),
        _createElementVNode("div", _hoisted_2, [
          (!activeFlag.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t("LoginModal.signIn")), 1),
                (_unref(isDev))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((innerLogin).value = $event))
                      }, null, 512), [
                        [
                          _vModelText,
                          innerLogin.value,
                          void 0,
                          { number: true }
                        ]
                      ]),
                      _createElementVNode("button", { onClick: handleInnerLogin }, _toDisplayString(_ctx.$t("LoginModal.handleInnerLogin")), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: "main-btn",
                  onClick: handleGoogleLogin
                }, [
                  _createElementVNode("img", {
                    src: require('@/assets/img/icon-google.svg'),
                    alt: ""
                  }, null, 8, _hoisted_5),
                  _createElementVNode("p", null, _toDisplayString(_ctx.$t("LoginModal.loginWithGoogle")), 1)
                ]),
                _createElementVNode("div", {
                  class: "main-btn",
                  onClick: handleFacebookLogin
                }, [
                  _createElementVNode("img", {
                    src: require('@/assets/img/icon-facebook.svg'),
                    alt: ""
                  }, null, 8, _hoisted_6),
                  _createElementVNode("p", null, _toDisplayString(_ctx.$t("LoginModal.loginWithFaceBook")), 1)
                ]),
                _createElementVNode("div", {
                  class: "sub-btn",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (handleNextLogin(emailConfig.flag)))
                }, [
                  _createElementVNode("img", {
                    src: require('@/assets/img/icon-email.svg'),
                    alt: ""
                  }, null, 8, _hoisted_7),
                  _createElementVNode("p", null, _toDisplayString(_ctx.$t("LoginModal.loginWithEmail")), 1)
                ]),
                _createElementVNode("div", {
                  class: "sub-btn",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (handleNextLogin(chikiiIdConfig.flag)))
                }, [
                  _createElementVNode("img", {
                    src: require('@/assets/img/icon-id.svg'),
                    alt: ""
                  }, null, 8, _hoisted_8),
                  _createElementVNode("p", null, _toDisplayString(_ctx.$t("LoginModal.loginWithId")), 1)
                ]),
                _createElementVNode("p", _hoisted_9, [
                  _createElementVNode("img", {
                    src: 
              require(`@/assets/img/icon-agree-${
                isAgree.value ? 'active' : 'default'
              }.png`)
            ,
                    onClick: handleAgree
                  }, null, 8, _hoisted_10),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("LoginModal.protocol")) + " ", 1),
                  _createElementVNode("span", {
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (gotoProtocolPage('terms')))
                  }, _toDisplayString(_ctx.$t("LoginModal.Terms")), 1),
                  _createTextVNode("& "),
                  _createElementVNode("span", {
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (gotoProtocolPage('privacy')))
                  }, _toDisplayString(_ctx.$t("LoginModal.PrivacyPolicy")), 1)
                ])
              ], 64))
            : (activeFlag.value === emailConfig.flag)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", {
                      class: "return-btn",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (activeFlag.value = ''))
                    }, [
                      _createElementVNode("img", {
                        src: require('@/assets/img/icon-return.svg'),
                        alt: ""
                      }, null, 8, _hoisted_12),
                      _hoisted_13
                    ]),
                    _createElementVNode("p", _hoisted_14, _toDisplayString(activeFlag.value.toUpperCase()) + " LOGIN", 1)
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "acount active",
                    placeholder: _ctx.$t('LoginModal.enterEmailText'),
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((emailAcount).value = $event))
                  }, null, 8, _hoisted_15), [
                    [_vModelText, emailAcount.value]
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "acount active",
                      placeholder: _ctx.$t('LoginModal.emilVerificationCode'),
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((emailVerifyCode).value = $event))
                    }, null, 8, _hoisted_17), [
                      [_vModelText, emailVerifyCode.value]
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass(["send-btn flex-btn", [!emailAcount.value || countTime.value ? 'disabled' : 'active']]),
                      onClick: handleSendVerifyCode
                    }, _toDisplayString(countTime.value ? `${countTime.value}s` : _ctx.$t("LoginModal.send")), 3)
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["login-btn flex-btn m-email", [_unref(checkCanLogin) ? 'active' : 'disabled']]),
                    onClick: handleEmailLogin
                  }, " Login ", 2),
                  _createVNode(_unref(Popover), {
                    trigger: "hover",
                    placement: "top",
                    overlayClassName: "popover-container",
                    color: "#333333"
                  }, {
                    content: _withCtx(() => [
                      _createVNode(_component_i18n_t, {
                        class: "tips-content",
                        tag: "div",
                        keypath: "LoginModal.verifyTips"
                      }, {
                        search: _withCtx(() => [
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t("LoginModal.search")), 1)
                        ]),
                        chikii: _withCtx(() => [
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t("LoginModal.chikii")), 1)
                        ]),
                        open: _withCtx(() => [
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t("LoginModal.open")), 1),
                          _createTextVNode(),
                          _hoisted_19
                        ]),
                        tips3: _withCtx(() => [
                          _createElementVNode("p", null, _toDisplayString(_ctx.$t("LoginModal.tips3")), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.$t("LoginModal.verifyCodeTips")), 1)
                    ]),
                    _: 1
                  })
                ], 64))
              : (activeFlag.value === chikiiIdConfig.flag)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", {
                        class: "return-btn",
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (activeFlag.value = ''))
                      }, [
                        _createElementVNode("img", {
                          src: require('@/assets/img/icon-return.svg'),
                          alt: ""
                        }, null, 8, _hoisted_21),
                        _hoisted_22
                      ]),
                      _createElementVNode("p", _hoisted_23, _toDisplayString(activeFlag.value.toUpperCase()) + " LOGIN", 1)
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "acount active",
                      placeholder: _ctx.$t('LoginModal.enterIDText'),
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((IdAcount).value = $event))
                    }, null, 8, _hoisted_24), [
                      [_vModelText, IdAcount.value]
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _withDirectives(_createElementVNode("input", {
                        type: `${isShowPassward.value ? 'text' : 'password'}`,
                        class: "acount active",
                        placeholder: _ctx.$t('LoginModal.enterPassWordText'),
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((IdPassword).value = $event))
                      }, null, 8, _hoisted_26), [
                        [_vModelDynamic, IdPassword.value]
                      ]),
                      _createElementVNode("img", {
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (isShowPassward.value = !isShowPassward.value)),
                        src: 
              require(`@/assets/img/${
                isShowPassward.value ? 'icon-eyes' : 'icon-shut'
              }.svg`)
            ,
                        alt: ""
                      }, null, 8, _hoisted_27)
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass(["login-btn flex-btn m-id", [_unref(checkCanLogin) ? 'active' : 'disabled']]),
                      onClick: handleIdLogin
                    }, " Login ", 2)
                  ], 64))
                : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(CusModal, {
      isShow: isAgreeProtoModal.value,
      width: "480px",
      title: _unref(t)('LoginModal.SignIn'),
      content: _unref(t)('LoginModal.agreeProtoModalContent'),
      onOnClose: _cache[13] || (_cache[13] = ($event: any) => (isAgreeProtoModal.value = false)),
      onOnCancel: _cache[14] || (_cache[14] = ($event: any) => (isAgreeProtoModal.value = false)),
      onOnConfirm: handleConfirm,
      cancelText: "Cancel",
      okText: "Confirm"
    }, null, 8, ["isShow", "title", "content"])
  ], 64))
}
}

})